module.exports = {"attributes":{"width":"50","height":"50","viewBox":"0 0 50 50","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"channel-icon-logo\" d=\"M23.6 13.8l-6.1 15h12l-5.9-15zM7 41.8c2.6 0 3.2-1.6 4.8-5.4l13-30.8c.1-.3.2-.6.5-.6.2 0 .3.2.5.6l12.9 31.8c1.4 3.4 2.2 4.4 4.3 4.4V43a82.8 82.8 0 0 0-12.2 0v-1.2c1 0 3 0 3-1.3 0-.8-.5-1.9-.9-2.8l-2.7-7H16.7l-3 7.2c-.3 1-.5 1.6-.5 2.1 0 1.7 1.8 1.8 3.1 1.8V43A56.4 56.4 0 0 0 7 43v-1.2z\" fill=\"#000\"/>"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/channel/apprl.svg
// module id = 1268
// module chunks = 0